import { Injectable } from '@angular/core';
import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { IListQueue } from '../_models/queuemanagement';
import { User } from '../_models';
import { IGroup } from '../_models/group';
import { AuthenticationService } from './authentication.service';
import { AppConfig } from 'src/assets/config/config/app-config';
import { GroupsComponent } from '../configuration/users-and-groups/groups/groups.component';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
  observe: 'response' as 'body',
};

@Injectable({
  providedIn: 'root',
})
export class QueueService {
  newQueue: IListQueue;
  currentUser: User;
  currentGroup: string[];
  apiUrl: string;
  workflowAPIUrl: string;

  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private config: AppConfig
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.currentGroup = this.authenticationService.userGroupsValue;
    this.apiUrl = this.config.getConfig('apiUrl');
    this.workflowAPIUrl = this.config.getConfig('workflowAPIUrl');
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(error);
  }

  getQueue(queueId): Observable<any> {
    return this.http.get<any>(
      this.workflowAPIUrl + `/docuedge/workflow/queue/` + queueId
    );
  }

  getAllQueues(): Observable<any> {
    return this.http.get<any>(this.workflowAPIUrl + `/docuedge/workflow/queue`);
  }

  getQueuesForUser(): Observable<any> {
    return this.http
      .get<any>(this.workflowAPIUrl + `/docuedge/workflow/getqueues`)
      .pipe(catchError(this.errorHandler));
  }
  // Add in queue name to url
  updateQueue(payload, queueName): Observable<any> {
    return this.http
      .put<any>(this.workflowAPIUrl + `/docuedge/workflow/queue/${queueName}`, payload)
      .pipe(catchError(this.errorHandler));
  }
  // Add in queue name to url
  createQueue(payload, queueName): Observable<any> {
    return this.http
      .post<any>(this.workflowAPIUrl + `/docuedge/workflow/queue/${queueName}`, payload)
      .pipe(catchError(this.errorHandler));
  }
}